const radius = {
	base: '8px',
	sm: '16px',
	lg: '24px',
};

export default radius;
